const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    display: 'block',
    marginTop: 0,
    paddingBottom: '12px'
  },
  block: {
    display: 'block'
  },
  modal: {
    minHeight: 400,
    minWidth: 600,
    maxWidth: 600,
    maxHeight: 300
  },
  modalHeader: {
    fontWeight: '600!important',
    fontSize: '1.2rem!important',
  },
  contain: {
    overflowY: 'scroll',
  },
  form: {
    height: 240,
    width: '100%',
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'initial',
    gap: '1rem',
  },
  formChild: {
    flexBasis: 'initial',
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: 'white',
    minWidth: 40,
  },
  close: {
    padding: 0,
    minWidth: 40,
  },
  flex: {
    flex: 1
  },
  summary: {
    padding: theme.spacing.unit
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '1rem',
    height: '40px',
  },
  instruction: {
    fontSize: '1rem',
  }
})

export default styles
